import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faq';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="defer-paint w-full bg-canvas py-12 sm:py-14" aria-labelledby="faq-heading" data-id="element-50" data-mp="1bl23p9e8x8f0">
      <div className="mx-auto max-w-3xl px-6" data-id="element-51" data-mp="1gj3obyrblfsl">
        <div className="text-center" data-id="element-52" data-mp="1gjvkpbsqrhjx">
          <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-accent" data-id="element-53" data-mp="249g41vst4gtq">Prima di decidere</p>
          <h2 id="faq-heading" className="mt-4 font-serif text-[2.2rem] font-bold leading-[1.05] text-ink sm:text-[2.6rem]" data-id="element-54" data-mp="28b1cn4yb68y4">
            Domande frequenti
          </h2>
        </div>

        <ul className="mt-10 space-y-2.5" data-id="element-55" data-mp="1zhy1x4f1sa76">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className={`rounded-3xl border bg-card transition-colors duration-150 ease-out ${isOpen ? 'border-accent/40' : 'border-line'}`} data-id="element-56" data-mp="2n7aaq36gqg8y" data-mpi={index}>
                <h3 data-id="element-57" data-mp="14ushx7tgeuxm">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 rounded-3xl px-6 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent" data-id="element-58" data-mp="14wbuoofwinun">
                    <span className="font-serif text-xl font-bold leading-snug text-ink sm:text-2xl" data-id="element-59" data-mp="19ska82y0gj2c">
                      {faq.question}
                    </span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-colors duration-150 ease-out ${isOpen ? 'border-accent bg-accent text-white' : 'border-accent/25 bg-accent-soft text-accent'}`} aria-hidden="true" data-id="element-60" data-mp="1jjojqn4x3bps">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-61" data-mp="3557qc33rrwf" />
                    </span>
                  </button>
                </h3>

                <div id={`faq-panel-${index}`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-62" data-mp="1y9wjb39ncxlm">
                  <div className="overflow-hidden" data-id="element-63" data-mp="2867vlt98lng2">
                    <p className="px-6 pb-6 font-sans text-[0.92rem] leading-relaxed text-muted" data-id="element-64" data-mp="289nbgyaqj0ij">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}